import { FC, Fragment } from 'react';

import { push } from 'connected-react-router';
import { Permissions } from 'utils/constants/permissions';

import { MenuItem } from 'bloko/blocks/drop/Menu/Click';

import useTrl from 'hooks/translation/useTrls';

import { useDispatch } from 'store/utils';

import styles from 'components/Admin/SectionTabs/SectionTabs.module.less';

interface ContentProps {
    permissions: Permissions[];
    data: Array<{
        code: string;
        path: string;
        permission: Permissions;
    }>;
}

const Content: FC<ContentProps> = ({ permissions, data }) => {
    const dispatch = useDispatch();
    const trl = useTrl();

    return (
        <>
            {data.map(({ code, path, permission }) => (
                <Fragment key={code}>
                    {permissions.includes(permission) && (
                        <MenuItem key={code} Element="button" onClick={() => dispatch(push(path))}>
                            <span className={styles.sectionTabsDditem}>{trl(`admin.SectionTabs.${code}`)}</span>
                        </MenuItem>
                    )}
                </Fragment>
            ))}
        </>
    );
};

export default Content;
